import i18n from '@/locales'
import { REPORT_TEMPLATES } from '@Reports/constants'
import { getSetApplicationScopeAction } from '@/utils/common/tableActions'

export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('table.action.modify'),
        permission: 'report_templates_update',
        action: (obj) => {
          this.$router.push({
            name: 'ReportTemplateCreate',
            params: {
              id: obj.id,
              templateData: obj,
              type: 'edit',
            },
          })
        },
        meta: (obj) => {
          return this.checkSameDomain ? this.checkSameDomain(obj) : { validate: true }
        },
      },
      {
        label: i18n.t('common.more'),
        actions: (obj) => {
          return [
            {
              label: i18n.t('table.action.clone'),
              permission: 'report_templates_create',
              action: (obj) => {
                this.$router.push({
                  name: 'ReportTemplateCreate',
                  params: {
                    id: obj.id,
                    templateData: obj,
                    type: 'clone',
                  },
                })
              },
              meta: (obj) => {
                return this.checkSameDomain ? this.checkSameDomain(obj) : { validate: true }
              },
            },
            getSetApplicationScopeAction(this, {
              name: this.$t('report.report_template'),
              scope: 'domain',
              resource: 'report_templates',
            }, {
              permission: 'report_templates_perform_public',
            }),
            {
              label: i18n.t('common.action.delete'),
              permission: 'report_settings_delete',
              action: () => {
                this.createDialog('DeleteResDialog', {
                  name: i18n.t('report.report_setting'),
                  title: i18n.t('common.action.delete'),
                  vm: this,
                  data: [obj],
                  columns: this.columns,
                  onManager: this.onManager,
                })
              },
              meta: (obj) => {
                const ret = { validate: true }
                if (!obj.can_delete) {
                  ret.validate = false
                  ret.tooltip = this.$t('report.report_template_is_been_used')
                  return ret
                }
                if (Object.keys(REPORT_TEMPLATES).includes(obj.id)) {
                  ret.validate = false
                  ret.tooltip = this.$t('report.default_report_not_delete')
                  return ret
                }
                if (ret.validate) {
                  return this.checkSameDomain(obj)
                }
                return ret
              },
            },
          ]
        },
      },
    ]
  },
  methods: {
    async generateReportValue (data) {
      try {
        await this.onManager('batchPerformAction', {
          id: [data.id],
          managerArgs: {
            action: 'generate-report',
          },
        })
        this.$message.success(this.$t('common_360'))
      } catch (err) {
        throw err
      }
    },
    checkSameDomain (data) {
      const ret = { validate: true }
      const { domain_id } = data
      if (!this.$store.getters.isAdminMode && domain_id !== this.$store.getters.userInfo.projectDomainId) {
        ret.validate = false
        ret.tooltip = this.$t('common_716')
      }
      return ret
    },
  },
}
